/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PagingAndSortingRequestParam } from './PagingAndSortingRequestParam';
import type { RiskAssessmentHazardFilter } from './RiskAssessmentHazardFilter';

export type RiskAssessmentHazardFilterDto = {
    exposeType?: RiskAssessmentHazardFilterDto.exposeType;
    riskAssessmentHazardFilter?: RiskAssessmentHazardFilter;
    pagingAndSortingRequestParam?: PagingAndSortingRequestParam;
}

export namespace RiskAssessmentHazardFilterDto {

    export enum exposeType {
        EXCEL = 'EXCEL',
        PDF = 'PDF',
        WORD = 'WORD',
        HTML = 'HTML',
        XML = 'XML',
        JSON = 'JSON',
        CSV = 'CSV',
    }


}
